import ToogleSwitch from '../../../../atoms/ToogleSwitch';

interface SwitchFieldProps {
    label: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

const SwitchField = ({ label, checked, disabled = false, onChange }: SwitchFieldProps) => (
    <div className={`flex items-center gap-2 ${disabled ? 'opacity-50' : ''}`}>
        <ToogleSwitch checked={checked} onChange={onChange} disabled={disabled} ariaLabel={label} />
        <span className="text-sm text-gray-700 dark:text-gray-200">{label}</span>
    </div>
);

export default SwitchField;
